import { BouncyCardsFeatures } from "./BouncyCardsFeatures";

export default BouncyCardsFeatures;